import React from 'react';
import { MapPin, Check } from 'lucide-react';

const ServiceAreaSection = () => {
  const areas = [
    'Northampton Town Centre',
    'Abington',
    'Duston',
    'Kingsthorpe',
    'Weston Favell',
    'Moulton',
    'Brixworth',
    'Wellingborough',
    'Kettering',
    'Daventry',
    'Towcester',
    'Brackley',
    'Rushden',
    'Corby',
  ];

  return (
    <section 
      id="service-area" 
      className="py-20 lg:py-28 bg-slate-900"
      data-testid="service-area-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-red-400 font-semibold text-sm tracking-wider uppercase mb-4">
              Service Area
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-['Manrope'] mb-6">
              Covering Northampton & Surrounding Areas
            </h2>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed">
              We're based in Northampton and cover the whole of 
              Northamptonshire. From central Northampton to the surrounding villages and 
              neighbouring towns, we're happy to travel.
            </p>
            
            {/* Map Placeholder */}
            <div className="relative bg-slate-800 rounded-2xl p-8 border border-slate-700">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="font-semibold text-white font-['Manrope']">Flex Plastering</p>
                  <p className="text-sm text-slate-400">Northampton Based</p>
                </div>
              </div>
              <p className="text-slate-400 text-sm">
                Approximately 30-mile radius of Northampton
              </p>
            </div>
          </div>

          {/* Right - Area List */}
          <div className="bg-slate-800 rounded-2xl p-8 lg:p-10 border border-slate-700">
            <h3 className="text-xl font-bold text-white font-['Manrope'] mb-6">
              Areas We Cover
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {areas.map((area, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-2 text-slate-300"
                  data-testid={`service-area-${index}`}
                >
                  <Check className="w-4 h-4 text-red-500 flex-shrink-0" />
                  <span className="text-sm">{area}</span>
                </div>
              ))}
            </div>
            
            {/* Outside Area Note */}
            <div className="mt-8 pt-6 border-t border-slate-700">
              <p className="text-slate-400 text-sm leading-relaxed">
                <span className="text-red-400 font-medium">Just outside these areas?</span>
                {' '}Give us a call anyway — depending on the project size, we may still 
                be able to help.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
